import { createTheme } from '@mui/material/styles';
import 'typeface-open-sans';
import { DARK_GREY_TEXT, RAKUNA_COLOR } from '../../shared/Constants';

const RakunaTheme = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    fontSize: 15,
    body1: {
      fontWeight: 400,
    },
    h4: {
      fontWeight: 400,
    },
    h5: {
      fontWeight: 400,
    },
    h6: {
      fontWeight: 400,
    },
  },
  zIndex: {
    appBar: 1009,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: DARK_GREY_TEXT,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#fafafa',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          color: 'unset',
          backgroundColor: 'unset',
          padding: '0.28125rem 1.375rem',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        },
        outlined: {
          padding: '0.21875rem 1.375rem',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          '&:hover': {
            border: '1px solid rgba(0, 0, 0, 0.23)',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: RAKUNA_COLOR,
          },
        },
      },
    },
  },
});

export default RakunaTheme;
